import { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { ErrorCodes, SuccessCodes } from "@/utils/getMessages";
interface UseHandleUrlStatusArgs {
  onSuccess: (success: SuccessCodes) => void;
  onError: (error: ErrorCodes) => void;
}

// Payment gateway redirect maps `?payment=success|failed` to these internal codes.
const PAYMENT_SUCCESS_CODE = "S-10028" as SuccessCodes;
const PAYMENT_FAILURE_CODE = "E-10072" as ErrorCodes;

export function useHandleUrlStatus(args: UseHandleUrlStatusArgs) {
  const { onSuccess, onError } = args;
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const successParam = searchParams.get("success") as SuccessCodes;
    const errorParam = searchParams.get("error") as ErrorCodes;
    // Handle gateway redirect: ?payment=success or ?payment=failed
    const paymentParam = searchParams.get("payment");

    const newParams = new URLSearchParams(searchParams);
    let paramsChanged = false;

    if (successParam && !paymentParam) {
      onSuccess?.(successParam);
      newParams.delete("success");
      paramsChanged = true;
    }

    if (errorParam && !paymentParam) {
      onError?.(errorParam);
      newParams.delete("error");
      paramsChanged = true;
    }

    if (paymentParam) {
      newParams.delete("payment");
      newParams.delete("order_id"); // also clean up the order_id appended by backend
      paramsChanged = true;
      if (paymentParam === "success") {
        onSuccess?.(PAYMENT_SUCCESS_CODE);
      } else if (paymentParam === "failed") {
        onError?.(PAYMENT_FAILURE_CODE);
      }
    }

    if (paramsChanged) {
      navigate({ search: newParams.toString() }, { replace: true });
    }
  }, [searchParams, navigate, onSuccess, onError]);
}


